"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateReports = exports.generateActivityReportsFromActivity = exports.generateActivityReportsDataFromQuestions = void 0;
const en_1 = require("@faker-js/faker/locale/en");
const tools_1 = require("../tools");
const types_1 = require("../types");
const jobs_1 = require("./../types/jobs");
const items_1 = require("./items");
const addMetadata = (answers, meta) => {
    if (!meta) {
        meta = {};
    }
    return Object.assign(Object.assign({}, answers), { _id: meta._id ? meta._id : (0, tools_1.IDSource)(), _step_id: meta._step_id ? meta._step_id : (0, tools_1.IDSource)(), _activity_id: meta._activity_id ? meta._activity_id : (0, tools_1.IDSource)(), _workflow_report_id: meta._workflow_report_id
            ? meta._workflow_report_id
            : (0, tools_1.IDSource)(), _workflow_id: meta._workflow_id ? meta._workflow_id : (0, tools_1.IDSource)(), _workflow_version: meta._workflow_version
            ? meta._workflow_version
            : en_1.faker.number.int(10) + "", _activity_version: meta._activity_version
            ? meta._activity_version
            : en_1.faker.number.int(10) + "", _displayed_name: meta._displayed_name
            ? meta._displayed_name
            : en_1.faker.person.firstName(), _started_at: meta._started_at ? meta._started_at : en_1.faker.date.recent(), _due_date: meta._due_date ? meta._due_date : en_1.faker.date.recent(), _created_at: meta._created_at ? meta._created_at : en_1.faker.date.recent(), _completed_at: meta._completed_at
            ? meta._completed_at
            : en_1.faker.date.recent(), _updated_locally_at: meta._updated_locally_at
            ? meta._updated_locally_at
            : en_1.faker.date.recent(), _created_locally_at: meta._created_locally_at
            ? meta._created_locally_at
            : en_1.faker.date.recent(), _updated_at: meta._updated_at ? meta._updated_at : en_1.faker.date.recent(), _created_by: meta._created_by
            ? meta._created_by
            : `${en_1.faker.person.firstName()} ${en_1.faker.person.lastName()}`, _completed_by: meta._completed_by
            ? meta._completed_by
            : `${en_1.faker.person.firstName()} ${en_1.faker.person.lastName()}`, _updated_by: meta._updated_by
            ? meta._updated_by
            : `${en_1.faker.person.firstName()} ${en_1.faker.person.lastName()}`, _customer_id: meta._customer_id ? meta._customer_id : (0, tools_1.IDSource)(), _duration: meta._duration ? meta._duration : en_1.faker.number.int(1000), _visit_id: meta._visit_id ? meta._visit_id : en_1.faker.number.int(1), _status: jobs_1.STEP_STATUS.DONE, _backend_version: meta._backend_version ? meta._backend_version : "1", _user_name: meta._user_name
            ? meta._user_name
            : `${en_1.faker.person.firstName()} ${en_1.faker.person.lastName()}`, _user_phone: meta._user_phone ? meta._user_phone : en_1.faker.phone.number() });
};
const generateActivityReportsDataFromQuestions = (questions, activityId, itemIds = []) => {
    const result = {};
    for (const question of questions) {
        const answer = generateAnswerData(question, itemIds);
        result[answer.attr_name] = answer.value;
    }
    // add metadatas
    return addMetadata(result, { _activity_id: activityId });
};
exports.generateActivityReportsDataFromQuestions = generateActivityReportsDataFromQuestions;
const generateActivityReportsFromActivity = (activity, itemIds = [], reportNumber) => {
    const result = [];
    if (!reportNumber) {
        reportNumber = en_1.faker.number.int({ min: 2, max: 10 });
    }
    for (let i = 0; i < reportNumber; i++) {
        const questions = [];
        activity.questionnaire.questions.forEach((q) => {
            questions.push(q);
        });
        result.push((0, exports.generateActivityReportsDataFromQuestions)(questions, activity.id, itemIds));
    }
    return result;
};
exports.generateActivityReportsFromActivity = generateActivityReportsFromActivity;
/**
Exepcted output for SC/MC question types:
"single_choice": "option_2",
"single_choice_on_list": "jhzaa6jm0himlsel",
"multiple_choice": [
    "choice_1",
    "choice_2",
    "choice_3"
],
"multiple_choice_on_list": [
    "DxjNsnhH2DBoTxGuPu9j"
]
 *  **/
const generateAnswerData = (question, itemIds) => {
    const questionTag = question.tag;
    const questionType = question.type;
    const options = question.options;
    const listId = question.list_id;
    const matrix = question.matrix;
    switch (questionType) {
        case types_1.CUSTOM_FIELD_TYPE.BARCODE_SCANNER:
        case types_1.CUSTOM_FIELD_TYPE.PICTURE:
        case types_1.CUSTOM_FIELD_TYPE.SIGNATURE:
        case types_1.CUSTOM_FIELD_TYPE.TEXT: {
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: en_1.faker.lorem.words(),
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE: {
            const optNumber = options.length - 1;
            const rdOptIdx = en_1.faker.number.int({ min: 0, max: optNumber });
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: options[rdOptIdx].value,
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_INTEGER:
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_INPUT_DECIMAL: {
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: {
                    value: en_1.faker.number.int(),
                    detail: JSON.stringify([]),
                },
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.DATE_PICKER: {
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: en_1.faker.date.anytime(),
                // {
                //   day: faker.number.int(30),
                //   month: faker.number.int(12),
                //   year: faker.number.int(2000),
                // },
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.TIME_PICKER: {
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: {
                    hour: en_1.faker.number.int(12),
                    minute: en_1.faker.number.int(60),
                },
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.DECIMAL: {
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: en_1.faker.number.float({ min: 1, max: 10, multipleOf: 0.01 }),
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.INTEGER: {
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: en_1.faker.number.int(30),
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.GPS: {
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: {
                    acc: en_1.faker.number.float({ multipleOf: 0.000000000001 }),
                    lng: en_1.faker.number.float({ min: 1, max: 10, multipleOf: 0.01 }),
                    lat: en_1.faker.number.float({ min: 1, max: 10, multipleOf: 0.01 }),
                },
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE: {
            let objValue = {};
            if (!options) {
                objValue = {
                    opt1: en_1.faker.datatype.boolean(),
                    opt2: en_1.faker.datatype.boolean(),
                    opt3: en_1.faker.datatype.boolean(),
                };
            }
            else {
                objValue = options.reduce((acc, curr) => {
                    acc[`${curr.key}`] = en_1.faker.datatype.boolean();
                    return acc;
                }, {});
            }
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: Object.keys(objValue).filter((key) => objValue[key]), // expect in the form of ["opt1", "opt3"]
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.MULTIPLE_CHOICE_ON_LIST: {
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: {
                    ids: itemIds.filter((i) => en_1.faker.datatype.boolean()),
                },
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.SINGLE_CHOICE_ON_LIST: {
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: itemIds.length > 0
                    ? itemIds[en_1.faker.number.int(itemIds.length - 1)]
                    : (0, tools_1.IDSource)(),
                // value: {
                //   id:
                //     itemIds.length > 0
                //       ? faker.helpers.arrayElement(itemIds)
                //       : IDSource(),
                //   list_id: listId ? listId : IDSource(),
                // },
            };
        }
        case types_1.CUSTOM_FIELD_TYPE.MATRIX_ON_LIST: {
            let valObj = {};
            if (matrix) {
                for (const header of itemIds) {
                    let subQuestionAnswers = {};
                    for (const subQuestion of matrix.typed_questions) {
                        const generatedAnswerForSubQuestion = generateAnswerData(subQuestion, itemIds);
                        subQuestionAnswers[`${generatedAnswerForSubQuestion.attr_name}`] =
                            generatedAnswerForSubQuestion.value;
                    }
                    valObj[`${header}`] = subQuestionAnswers;
                }
            }
            else {
                valObj = {
                    headerKey1: {
                        subQuestionTag1: en_1.faker.lorem.words(),
                        subQuestionTag2: en_1.faker.lorem.words(),
                    },
                    headerKey2: {
                        subQuestionTag1: en_1.faker.lorem.words(),
                        subQuestionTag2: en_1.faker.lorem.words(),
                    },
                };
            }
            return {
                attr_name: questionTag
                    ? `${questionTag}`
                    : `${questionType}_${en_1.faker.lorem.word()}`,
                value: valObj,
            };
        }
    }
    return {
        attr_name: questionTag
            ? `${questionTag}`
            : `${questionType}_${en_1.faker.lorem.word()}`,
        value: en_1.faker.lorem.words(),
    };
};
/**
 * WARNING: DO NOT IMPORT IN smala-admin-dashboards, this would increase the bundle size by 1Mb because of the ES and FR versions of faker
 */
const generateReports = (activity, itemIds = {}, number_of_reports = 1, backtrack_time = 0, infos, lang = types_1.LANGUAGE.en) => {
    var _a;
    let questions = [];
    questions = activity.questionnaire.questions;
    const reports = [];
    for (let i = 0; i < number_of_reports; i++) {
        const answers = questions.map((question) => (0, items_1.generateAnswerDataMobileFormat)(question, itemIds, lang));
        const checkInDate = new Date(Date.now() - en_1.faker.number.int({ min: 0, max: backtrack_time }) * 60 * 1000);
        const startedDate = new Date(checkInDate.getTime() + en_1.faker.number.int({ min: 1, max: 5 }) * 1000 * 60);
        const completedDate = new Date(startedDate.getTime() + en_1.faker.number.int({ min: 1, max: 5 }) * 1000 * 60);
        const checkOutDate = new Date(completedDate.getTime() + en_1.faker.number.int({ min: 1, max: 5 }) * 1000 * 60);
        const id = (0, tools_1.IDSource)();
        const report = Object.assign({ id, activity_id: activity.id, activity_version: activity.version, workflow_id: infos.workflow_id, workflow_version: infos.workflow_version, step_id: infos.step_id, workflow_report_id: infos.workflow_report_id, displayed_name: infos.displayed_name || "", started_at: en_1.faker.date.recent().toISOString(), completed_at: completedDate.toISOString(), completed_by: infos.created_by || "", created_by: infos.completed_by || "", created_locally_at: new Date().toISOString(), custom_field_values: answers }, (((_a = itemIds["customer"]) === null || _a === void 0 ? void 0 : _a.length) &&
            infos.report_prerequisite &&
            infos.report_prerequisite != types_1.REPORT_PREREQUISITE.NO_NEED && {
            customer_id: en_1.faker.helpers.arrayElement(itemIds["customer"]),
        }));
        reports.push(report);
    }
    return reports;
};
exports.generateReports = generateReports;
